import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

export function WaitlistCapture({ subjectType, subjectId, placeholder = "Your email", cta = "Join Waitlist", dark = false, className = "" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/inquiries", { subject_type: subjectType, subject_id: subjectId, name: "Waitlist signup", email, phone: "", message: `Waitlist signup for ${subjectId}` });
      setDone(true); setEmail(""); toast.success("You're on the list — we'll be in touch.");
    } catch { toast.error("Could not sign you up. Please try again."); }
    finally { setBusy(false); }
  };
  if (done) return <p className={`text-sm font-semibold ${dark ? "text-white" : "text-eon-gold"}`} data-testid={`waitlist-done-${subjectId}`}>✓ You're on the waitlist. Thank you!</p>;
  return (
    <form onSubmit={submit} className={`flex flex-col sm:flex-row gap-3 max-w-md ${className}`} data-testid={`waitlist-form-${subjectId}`}>
      <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={placeholder}
        data-testid={`waitlist-email-${subjectId}`}
        className={`flex-1 rounded-full px-5 py-3 text-sm outline-none border ${dark ? "bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:border-white" : "bg-white border-eon-border text-eon-text focus:border-eon-gold"}`} />
      <button type="submit" disabled={busy} data-testid={`waitlist-submit-${subjectId}`}
        className={`rounded-full px-6 py-3 text-sm font-bold whitespace-nowrap transition-colors disabled:opacity-50 ${dark ? "bg-white text-eon-gold hover:bg-white/90" : "bg-eon-gold text-white hover:bg-eon-goldhover"}`}>
        {busy ? "Joining..." : cta}
      </button>
    </form>
  );
}
